import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CoinFranc = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M12 4.667a7.333 7.333 0 110 14.666 7.333 7.333 0 010-14.666zM12 6a6 6 0 100 12 6 6 0 000-12zm2 2.667a.667.667 0 01.078 1.329L14 10h-2a.666.666 0 00-.662.589l-.005.078v.666h2a.667.667 0 01.078 1.33l-.078.004h-2v.666H12a.667.667 0 01.078 1.33l-.078.004h-.667v.666a.667.667 0 01-1.329.078L10 15.333v-.666h-.667a.667.667 0 01-.077-1.33l.077-.004H10v-2.666a2 2 0 011.882-1.997L12 8.667h2z"
          id="coinfranc-line-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="coinfrank-line-b" fill="#fff">
          <use xlinkHref="#coinfranc-line-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#coinfranc-line-a" />
        <g
          mask="url(#coinfrank-line-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M12 4a8 8 0 100 16 8 8 0 000-16zm0 14.667A6.674 6.674 0 015.333 12 6.674 6.674 0 0112 5.333 6.674 6.674 0 0118.667 12 6.674 6.674 0 0112 18.667zm0-12a5.334 5.334 0 100 10.667 5.334 5.334 0 000-10.667zM14 10h-2a.667.667 0 00-.667.667v.666h2a.666.666 0 110 1.334h-2v.666H12a.666.666 0 110 1.334h-.667v.666a.666.666 0 11-1.333 0v-.666h-.667a.666.666 0 110-1.334H10v-2.666c0-1.103.897-2 2-2h2A.666.666 0 1114 10z"
          id="coinfranc-solid-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="coinfranc-solid-b" fill="#fff">
          <use xlinkHref="#coinfranc-solid-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#coinfranc-solid-a" />
        <g
          mask="url(#coinfranc-solid-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
